(function() {
  function initShopBySlider(lpSliders) {
    lpSliders.forEach((el) => {
      // let m_item_to_show = 2;
      // let disable = false;
      // if (el.classList.contains('sbr__listing')) {
      //     m_item_to_show = 2.7;
      //     disable = true;
      // }

      const lpSlider=tns({
        container: el,
        items: 2.7,
        gutter: 20,
        slideBy: 'page',
        center: false,
        autoplay: false,
        controls: false,
        nav: true,
        navPosition: 'bottom',
        mouseDrag: true,
        disable: false,
        preventScrollOnTouch: 'auto',
        responsive: {
          769: {
            items: 4,
            controls: true,
            disable: true,
          }
        }
      });
    });
  }
  //const lpShopBySlider = document.querySelectorAll('.lp-slider');
  //initShopBySlider(lpShopBySlider);

  const revealButton=document.querySelectorAll('.read-more-btn');
  const revealSeoButton=document.querySelectorAll('.read-more-btn-seo');
  const initReveal=(selector) => {
    selector.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.target.parentNode.classList.toggle('active-wrapper');
        if(el.classList.contains('reveal-show-title')) {
          el.classList.toggle('reveal-show-title');
          el.innerHTML="READ LESS"
        } else {
          el.classList.toggle('reveal-show-title');
          el.innerHTML="READ MORE"
        }
      })

    })
  }
  initReveal(revealButton);
  initReveal(revealSeoButton);

  const featuredBrandSlider=(brandsSlider) => {
    if(!brandsSlider) { return; }
    let m_item_to_show=2.6;
    let disable=false;
    var slider=tns({
      container: brandsSlider,
      items: m_item_to_show,
      gutter: 0,
      slideBy: 'page',
      center: false,
      autoplay: false,
      controls: true,
      nav: true,
      navPosition: 'bottom',
      mouseDrag: true,
      preventScrollOnTouch: 'auto',
      responsive: {
        768: {
          disable: disable,
          items: 4,
          controls: true,
          nav: false,
        }
      }
    });
  }
  const brandsSlider=document.querySelector('.ptp-brands-listing');
  featuredBrandSlider(brandsSlider);

  const featuredRowsSlider=(rowsSlider) => {
    if(!rowsSlider) { return; }
    const imagewithtextSlider=tns({
      container: rowsSlider,
      items: 1,
      slideBy: 1,
      gutter: 0,
      center: false,
      autoplay: false,
      controls: false,
      nav: false,
      navPosition: 'bottom',
      mouseDrag: true,
      autoHeight: true,
      startIndex: 0,
      preventScrollOnTouch: 'auto',
      responsive: {
        768: {
          nav: true,
          mouseDrag: false,
          autoHeight: true,
        }
      }
    });
    const coltrol_btns=rowsSlider.querySelectorAll('.tns-controls--customize button');
    coltrol_btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        if(btn.getAttribute('data-controls')=='prev') {
          imagewithtextSlider.goTo('prev');
        } else {
          imagewithtextSlider.goTo('next');
        }
      })
    });
    const nav_btns=rowsSlider.querySelectorAll('.tns-nav--customize button');
    nav_btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const index=btn.getAttribute('data-nav')||0;
        imagewithtextSlider.goTo(index);
      })
    });
    imagewithtextSlider.events.on('indexChanged', function(info, eventName) {
      var indexPrev=info.slideItems[info.indexCached].getAttribute('data-slide'),
        indexCurrent=info.slideItems[info.index].getAttribute('data-slide');

      nav_btns.forEach(btn => {
        //console.log(navCurrent, indexPrev);
        if(btn.getAttribute('data-nav')==indexCurrent) {
          btn.classList.add('tns-nav-active');
        } else {
          btn.classList.remove('tns-nav-active');
        }
      })
    });

    imagewithtextSlider.events.on('newBreakpointEnd', function(info, eventName) {
      imagewithtextSlider.updateSliderHeight()
    })
  }
  const rowsSlider=document.querySelector('.feature-row-slider');
  featuredRowsSlider(rowsSlider);

  initAccordion;


  function initCollectionSlider(sliders) {
    if(sliders.length>0) {
      sliders.forEach((el) => {
        var slider=tns({
          container: el,
          items: 2,
          gutter: 20,
          slideBy: 'page',
          center: false,
          autoplay: false,
          controls: false,
          nav: true,
          navPosition: 'bottom',
          mouseDrag: true,
          preventScrollOnTouch: 'auto',
          responsive: {
            768: {
              items: 4,
            }
          }
        });
      });
    }
  }
  const lpCollectionSlider=document.querySelectorAll('.recommendations-slider');
  initCollectionSlider(lpCollectionSlider);
})();

if(document.querySelector('ul.account-nav')) {
  document.querySelector('ul.account-nav').addEventListener("click", function() {
    if(this.classList.contains('opened')) {
      this.classList.remove('opened')
    } else {
      this.classList.add('opened')
    }
  });
}